export const environment = {
  production: true,
  WEB_SOCKET_URL: '#{tradeEngineEndpoint}#',
  APPLICATION_ID: 'backoffice',
  API_BASE_URL: '#{apiEndpoint}#',
  API_DASH_BASE_URL: 'https://dashboard-api.ozcambio.com.br/api',
  BACKOFFICE_URL: '#{backofficeUrl}#',
};

export const MERCHANT_DEFAULT = 'xavi-pay';

// So está aqui para referencia
export const LINK_REFINITV = 'https://ozcambio.fx.com/client/';

export const TOKEN_DASHBOARD =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJpbnRlZy5oYi1wcm9kIiwiYXV0aCI6IklOVEVHUkFUSU9OIiwicGxheWVyIjoiMyIsIm5hbWVpZCI6IjQxZGZkZjFjLWM4OTgtNGM1My1iYzM0LTAwNWU4YjRmMzUxYyIsIm5iZiI6MTcyMTMwNjQ3OSwiZXhwIjoxNzIxMzEyNDc5LCJpYXQiOjE3MjEzMDY0Nzl9.-l2Dy5ykXxCSnAQCFST8lwrosK-jHUL0kVdpVcAgqSw';
